import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ServicejobSearchComponent } from './servicejob-search.component';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule],
    declarations: [ServicejobSearchComponent],
    exports: [ServicejobSearchComponent]
})
export class ServicejobSearchModule {}
